/*!
=========================================================
* Painel Toca da Onça — Vendedores
=========================================================
*/
import React from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Table, Badge } from "reactstrap";

const brl = (v) => "R$ " + Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function UserProfile() {
  const [vendas, setVendas] = React.useState([]);
  React.useEffect(() => {
    try { setVendas(JSON.parse(localStorage.getItem("vendas_pdv") || "[]")); } catch (e) {}
  }, []);
  const hoje = new Date().toISOString().slice(0, 10);
  const doDia = vendas.filter((v) => v.data === hoje);

  const VENDEDORES = ["Ana", "Bia", "Carla"];
  const linhas = VENDEDORES.map((nome) => {
    const suas = doDia.filter((v) => v.vendedor === nome);
    const total = suas.reduce((s, v) => s + v.total, 0);
    return { nome, vendas: suas.length, total, comissao: total * 0.05 };
  });

  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 className="text-white" style={{ fontWeight: 300 }}>Vendedores</h3>
          <p className="text-muted">Cada vendedor tem seu caixa e sua comissão (5%). Login individual entra na próxima fase.</p>
        </Col>
      </Row>
      <Row>
        <Col xs="12">
          <Card>
            <CardHeader><CardTitle tag="h4">Desempenho de hoje</CardTitle></CardHeader>
            <CardBody>
              <Table className="tablesorter" responsive>
                <thead className="text-primary">
                  <tr><th>Vendedor(a)</th><th className="text-center">Vendas</th><th className="text-center">Caixa</th><th className="text-center">Comissão (5%)</th></tr>
                </thead>
                <tbody>
                  {linhas.map((l, i) => (
                    <tr key={i}>
                      <td><Badge color="primary" pill style={{ marginRight: 8 }}>{l.nome.charAt(0)}</Badge>{l.nome}</td>
                      <td className="text-center">{l.vendas}</td>
                      <td className="text-center text-success">{brl(l.total)}</td>
                      <td className="text-center text-warning">{brl(l.comissao)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default UserProfile;
